import React from 'react'
import { string } from 'prop-types'

const Label = ({
  text,
  labelFor = '',
  description
}) => (<div className='nft-label__container'>
  <label className='nft-label__text' htmlFor={labelFor}>{text}</label>
  {description && <p className='nft-label__description'>{description}</p>}
</div>)

Label.propTypes = {
  text: string.isRequired,
  labelFor: string,
  description: string
}

export default Label